class PrismicError extends Error {
  name = "SMPrismicError";
}
class UnauthenticatedError extends PrismicError {
  name = "SMUnauthenticatedError";
  message = "Authenticate before trying again.";
}
class UnexpectedDataError extends PrismicError {
  name = "SMUnexpectedDataError";
}
class InternalError extends PrismicError {
  name = "SMInternalError";
}
export {
  InternalError,
  PrismicError,
  UnauthenticatedError,
  UnexpectedDataError
};
//# sourceMappingURL=errors.js.map
